import { IAugmentedJQuery, IComponentOptions, IDocumentService, IScope } from 'angular';
import { DocumentClickAbstractController } from '../../abstract';
import './gmc-dropdown-menu.component.scss';

export class GmcDropdownMenuController extends DocumentClickAbstractController {
  static $inject = [
    '$element',
    '$document',
    '$scope'
  ];
  public position: 'left' | 'right' = 'left';
  public icon = 'more_vert';

  constructor( $element: IAugmentedJQuery,
               $document: IDocumentService,
               $scope: IScope ) {
    super($element, $document, $scope);
  }

}

export const GmcDropdownMenuComponent: IComponentOptions = {
  controller: GmcDropdownMenuController,
  template: require('./gmc-dropdown-menu.component.html'),
  transclude: true,
  bindings: {
    position: '@?'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/gmc-dropdown-menu/gmc-dropdown-menu.component.ts